import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PRODUCT_CARD_FIELDS, SHORTCUT_PRODUCT_FIELDS, SHORTCUT_PRODUCT_SHOP_INFO } from '@shared/api/shortcuts'

import type { Category, GQL_ID } from '@@types'


export type CategoriesPreviewProductsQuery = {
  categories?: Category[] | null
}

export type CategoriesPreviewProductsVariables = {
  shop_id: GQL_ID
  parentId?: GQL_ID | null
  ids?: Array<GQL_ID | null> | null
  style?: string
}

export const GQL_QUERY_CATEGORIES_PREVIEW_PRODUCTS = gql`
  query categoriesPreviewProducts(
    $shop_id: ID!
    $parentId: ID
    $style: String
    $ids: [ID]
  ) {
    categories(
      shop_id: $shop_id
      parent_id: $parentId
      ids: $ids
    ) {
      id
      name
      slug
      is_alcohol
      parent_id
      preview_size
      icon(style: $style) { url }
      miniIcon(style: $style) { url }
      products {
        ${SHORTCUT_PRODUCT_FIELDS}
        ${SHORTCUT_PRODUCT_SHOP_INFO}
        ${SHORTCUT_PRODUCT_CARD_FIELDS}
      }
    }
  }
`

export const useCategoriesPreviewProducts = (
  variables: CategoriesPreviewProductsVariables,
  options?: Parameters<
    typeof useQuery<CategoriesPreviewProductsQuery, CategoriesPreviewProductsVariables>
  >[1],
) => {
  const result = useQuery<CategoriesPreviewProductsQuery, CategoriesPreviewProductsVariables>(
    GQL_QUERY_CATEGORIES_PREVIEW_PRODUCTS,
    {
      variables,
      fetchPolicy: 'cache-and-network',
      skip: options?.skip ?? !variables.shop_id,
      ...options,
    }
  )

  const categories = result.data?.categories ?? []

  return {
    categories,
    ...result
  }
}
